
import Testimonials from "~/assets/testimonials.json";

export default {
  data() {
    return {
      Testimonials,
    };
  },

  head() {
    return {
      title: "Nos clients témoignent de leurs expériences | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Les projets de nos clients expliqués : création de site internet, de cartes de visite, stratégies de référencement payant et naturel. C'est à votre tour !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/blog/thumbnail-header-21.jpeg"),
        // },
      ],
    };
  },

  computed: {
    twoFirstTestimonial() {
      return this.Testimonials.filter((x) => Testimonials.indexOf(x) <= 1);
    },

    withouTwoFirstTestimonial() {
      return this.Testimonials.filter((x) => Testimonials.indexOf(x) > 1);
    },
  },
};
